module.exports = __webpack_public_path__ + "static/s-3e67fcdc6aad16c2f16c4490bdfa1c17.jpg";